import Vue from "vue";
import App from './App.vue'
import router from "@/router";
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import './assets/css/global.css'
import './assets/css/icon.css'
import './assets/css/mixins.scss'
import '@/plugins/index'
import  directive from './directive/index'
import cytoscape from 'cytoscape';
import wDesignUi from 'w-design-ui/w-design-ui.umd.min'
import 'w-design-ui/w-design-ui.css'
import Fragment from 'vue-fragment'
import VCalendar from 'v-calendar';
import '@/dialog/index';
// 引入 FontAwesome 的 CSS 文件
import '@fortawesome/fontawesome-free/css/all.min.css';
import vant from '@/plugins/vant.js'
import PortalVue from 'portal-vue'

vant();
Vue.use(PortalVue)
Vue.use(Fragment.Plugin)
Vue.use(VCalendar);
Vue.config.productionTip = false;
Vue.prototype.$cytoscape = cytoscape;
ElementUI.Dialog.props.closeOnClickModal.default = false
Vue.use(wDesignUi)
Vue.use(ElementUI)
Vue.use(Antd);
Vue.use(directive)
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
